import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigWithAuthCred } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const getAccDetails = (tokens: any, userAccessToken: string, dataObj: any, mobile: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.getAccountDetails,
    method: 'POST',
    config: sitConfigWithAuthCred(tokens, mobile),
    body: dataObj,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken ?? '',
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getAccDetails }
